import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import { useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ScrollableRow from '../../ui/ScrollableRow';
import GameNavButton from '../../ui/GameNavButton';
import AdminPreviewGameNavButton from '../../ui/AdminPreviewGameNavButton';
const AdminPreviewGameNavBar = ({ disable = false, currentTaskId, onNavButtonClick, tasks, currentTaskNumber, }) => {
    const { t } = useTranslation();
    const buttonRefs = useRef([]);
    useEffect(() => {
        const index = tasks.findIndex((task) => task.uid === currentTaskId);
        const button = buttonRefs.current[index];
        if (button) {
            button.scrollIntoView({
                behavior: 'smooth',
                inline: 'center',
                block: 'nearest',
            });
        }
    }, [currentTaskId, tasks]);
    return (_jsx("div", { className: `game-nav-bar${disable ? ' disable' : ''}`, children: _jsxs(ScrollableRow, { gap: '2px', children: [_jsx(GameNavButton, { status: 'start', label: t('button.start'), disabled: true }), tasks.map((task, index) => {
                    return (_jsx(AdminPreviewGameNavButton, { label: String(task.sorting), onClick: onNavButtonClick ? () => onNavButtonClick(task.sorting) : undefined, disabled: task.uid === currentTaskId || disable, isCurrent: task.sorting === +currentTaskNumber, ref: (el) => {
                            if (el) {
                                buttonRefs.current[index] = el;
                            }
                        } }, task.uid));
                }), _jsx(GameNavButton, { status: 'end', label: t('button.end'), disabled: true })] }) }));
};
export default AdminPreviewGameNavBar;
